import HayaSelectConfiguration from "haya-select/build/config"
import I18n from "shared/i18n"

HayaSelectConfiguration.current().setUseTranslate(() => ({
  t: (...args) => I18n.t(...args)
}))
